<mat-form-field class="full-width" *ngIf="!numberValue; else numberInput">
  <mat-label *ngIf="placeholder">{{placeholder | translate}}</mat-label>
  <input matInput
         [id]="id"
         [formControl]="formControl"
         [required]="required"
         [readonly]="true"
         [ngClass]="['readonlyColor','readonlyCursor']">
  <span matSuffix *ngIf="matSuffix">{{ matSuffix }}</span>
</mat-form-field>

<ng-template #numberInput>
  <mat-form-field class="full-width">
    <mat-label *ngIf="placeholder">{{placeholder | translate}}</mat-label>
    <input matInput
           numbers
           [id]="id"
           [precision]="2"
           [formControl]="formControl"
           [required]="required"
           [readonly]="true"
           [ngClass]="['readonlyColor','readonlyCursor']">
    <span matSuffix *ngIf="matSuffix">{{ matSuffix }}</span>
  </mat-form-field>
</ng-template>

  
